import {
  INDIVIDU_INICIALITZAR,
  INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
  INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnviarFormulariEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDIVIDU_INICIALITZAR:
      return ESTAT_INICIAL;

    case INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS:
      return true;

    case INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA:
      return false;

    default:
      return state;
  }
};

export default peticioEnviarFormulariEnCurs;
